import { useState, useEffect } from "react";

function CargaDispo({ usuario }) {
  const esAdmin = (usuario?.rol || "").toLowerCase() === "administrador";

  const [archivo, setArchivo] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [error, setError] = useState(null);

  const [cortes, setCortes] = useState([]);
  const [corteSeleccionado, setCorteSeleccionado] = useState("");
  const [heredando, setHeredando] = useState(false);
  const [resultadoHerencia, setResultadoHerencia] = useState(null);
  const [errorHerencia, setErrorHerencia] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/cortes-disponibles`)
      .then(r => r.json())
      .then(data => setCortes(Array.isArray(data) ? data : []))
      .catch(() => setCortes([]));
  }, [resultado]);

  // Bloqueo para no admins
  if (!esAdmin) {
    return (
      <div style={{ padding: "40px", textAlign: "center" }}>
        <div style={{ background: "#fef2f2", border: "1px solid #fca5a5", borderRadius: "12px", padding: "40px", maxWidth: "400px", margin: "0 auto" }}>
          <div style={{ fontSize: "48px", marginBottom: "16px" }}>🔒</div>
          <h3 style={{ color: "#991b1b", margin: "0 0 8px 0" }}>Acceso restringido</h3>
          <p style={{ color: "#64748b", fontSize: "14px", margin: 0 }}>Esta sección solo está disponible para el Administrador.</p>
        </div>
      </div>
    );
  }

  const handleSeleccionar = (e) => {
    setArchivo(e.target.files[0]);
    setResultado(null);
    setError(null);
  };

  const handleCargar = async () => {
    if (!archivo) return alert("Selecciona un archivo primero");
    const ext = archivo.name.split(".").pop().toLowerCase();
    if (!["csv", "xls", "xlsx"].includes(ext)) {
      return setError("Solo se permiten archivos CSV, XLS o XLSX");
    }
    const formData = new FormData();
    formData.append("archivo", archivo);
    setCargando(true); setResultado(null); setError(null);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/cargar-dispo`, { method: "POST", body: formData });
      const data = await res.json();
      if (data.ok) setResultado(data);
      else setError(data.mensaje || data.error || "Error desconocido");
    } catch {
      setError("No se pudo conectar con el servidor");
    } finally {
      setCargando(false);
    }
  };

  const handleHerenciaManual = async () => {
    if (!corteSeleccionado) return alert("Selecciona un corte primero");
    setHeredando(true); setResultadoHerencia(null); setErrorHerencia(null);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/heredar-causas`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fecha_corte_destino: corteSeleccionado })
      });
      const data = await res.json();
      if (data.ok) setResultadoHerencia(data);
      else setErrorHerencia(data.mensaje || "No se pudo aplicar la herencia");
    } catch {
      setErrorHerencia("No se pudo conectar con el servidor");
    } finally {
      setHeredando(false);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ color: "#000" }}>⬆️ Cargar Disponibilidad</h2>

      <div style={{ background: "#fff", borderRadius: "12px", padding: "32px", border: "1px solid #e5e7eb", maxWidth: "580px", boxShadow: "0px 10px 25px rgba(0,0,0,0.08)", marginBottom: "24px" }}>
        <h3 style={{ margin: "0 0 8px 0", color: "#111" }}>📂 Nuevo corte de disponibilidad</h3>
        <p style={{ color: "#6b7280", fontSize: "14px", margin: "0 0 24px 0" }}>
          Selecciona el archivo descargado (<strong>CSV, XLS o XLSX</strong>).<br />
          Los registros nuevos se suman a la tabla. Los duplicados se ignoran automáticamente.<br />
          <span style={{ color: "#2563eb", fontWeight: "600" }}>
            🔍 Solo se cargan los registros de la <strong>Región 3</strong> (columna Region Convergencia).
          </span><br />
          <span style={{ color: "#E30613", fontWeight: "600" }}>
            Si el corte es del mismo mes que el anterior, se heredan automáticamente causas, incumplimientos y observaciones por nodo.
          </span>
        </p>

        <div style={{ border: "2px dashed #d1d5db", borderRadius: "8px", padding: "24px", textAlign: "center", marginBottom: "20px", background: "#f9fafb" }}>
          <input type="file" accept=".csv,.xls,.xlsx" onChange={handleSeleccionar} style={{ display: "none" }} id="fileInput" />
          <label htmlFor="fileInput" style={{ cursor: "pointer" }}>
            <div style={{ fontSize: "32px", marginBottom: "8px" }}>📄</div>
            <div style={{ color: "#374151", fontWeight: "600" }}>
              {archivo ? archivo.name : "Haz clic para seleccionar el archivo"}
            </div>
            {archivo && <div style={{ color: "#6b7280", fontSize: "13px", marginTop: "4px" }}>{(archivo.size / 1024).toFixed(1)} KB</div>}
          </label>
        </div>

        <button onClick={handleCargar} disabled={!archivo || cargando} style={{
          background: cargando ? "#9ca3af" : "#ef4444", color: "white", border: "none",
          borderRadius: "8px", padding: "12px 24px", fontSize: "15px", fontWeight: "600",
          cursor: cargando ? "not-allowed" : "pointer", width: "100%"
        }}>
          {cargando ? "⏳ Cargando, espera..." : "⬆️ Cargar a la base de datos"}
        </button>

        {resultado && (
          <div style={{ marginTop: "20px", background: "#f0fdf4", border: "1px solid #86efac", borderRadius: "8px", padding: "20px" }}>
            <p style={{ margin: "0 0 12px 0", color: "#166534", fontWeight: "700", fontSize: "16px" }}>✅ Carga completada</p>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px", marginBottom: "12px" }}>
              {[
                { label: "Registros Región 3", value: resultado.total_archivo, bg: "#dcfce7", color: "#14532d" },
                { label: "Insertados",           value: resultado.insertadas,    bg: "#dcfce7", color: "#14532d" },
                { label: "Duplicados ignorados", value: resultado.duplicadas,    bg: "#fef9c3", color: "#713f12" },
                { label: "Nodos con herencia",   value: resultado.heredadas ?? 0, bg: (resultado.heredadas ?? 0) > 0 ? "#dbeafe" : "#f1f5f9", color: (resultado.heredadas ?? 0) > 0 ? "#1e3a8a" : "#475569" },
              ].map((k, i) => (
                <div key={i} style={{ background: k.bg, borderRadius: "6px", padding: "10px 14px" }}>
                  <div style={{ fontSize: "11px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.05em", color: k.color, opacity: 0.8 }}>{k.label}</div>
                  <div style={{ fontSize: "22px", fontWeight: "800", color: k.color }}>{k.value}</div>
                </div>
              ))}
            </div>
            {resultado.mensaje_herencia && (
              <div style={{ background: (resultado.heredadas ?? 0) > 0 ? "#dbeafe" : "#f8fafc", border: `1px solid ${(resultado.heredadas ?? 0) > 0 ? "#93c5fd" : "#e2e8f0"}`, borderRadius: "6px", padding: "10px 14px", display: "flex", alignItems: "flex-start", gap: "8px" }}>
                <span>{(resultado.heredadas ?? 0) > 0 ? "🔁" : "ℹ️"}</span>
                <div>
                  <span style={{ fontSize: "13px", color: (resultado.heredadas ?? 0) > 0 ? "#1e40af" : "#64748b", fontWeight: "500" }}>{resultado.mensaje_herencia}</span>
                  {resultado.corte_anterior_usado && <div style={{ fontSize: "12px", color: "#64748b", marginTop: "4px" }}>Corte origen: <strong>{resultado.corte_anterior_usado}</strong></div>}
                </div>
              </div>
            )}
          </div>
        )}

        {error && (
          <div style={{ marginTop: "20px", background: "#fef2f2", border: "1px solid #fca5a5", borderRadius: "8px", padding: "16px" }}>
            <p style={{ margin: 0, color: "#991b1b", fontWeight: "600" }}>❌ {error}</p>
          </div>
        )}
      </div>

      {/* Herencia manual */}
      <div style={{ background: "#fff", borderRadius: "12px", padding: "28px", border: "1px solid #e5e7eb", maxWidth: "580px", boxShadow: "0px 10px 25px rgba(0,0,0,0.08)" }}>
        <h3 style={{ margin: "0 0 6px 0", color: "#111" }}>🔁 Aplicar herencia manualmente</h3>
        <p style={{ color: "#6b7280", fontSize: "13px", margin: "0 0 20px 0" }}>
          Si ya cargaste un corte y la herencia no se aplicó automáticamente, selecciona la fecha del corte destino y aplícala ahora.
        </p>
        <label style={{ fontWeight: "600", fontSize: "13px", display: "block", marginBottom: "8px" }}>Corte destino:</label>
        <select value={corteSeleccionado} onChange={e => { setCorteSeleccionado(e.target.value); setResultadoHerencia(null); setErrorHerencia(null); }}
          style={{ width: "100%", padding: "10px 12px", borderRadius: "8px", border: "1px solid #d1d5db", fontSize: "14px", marginBottom: "14px", background: "#f9fafb", color: "#111" }}>
          <option value="">— Selecciona un corte —</option>
          {(cortes || []).map((c, i) => <option key={i} value={c}>{c}</option>)}
        </select>
        <button onClick={handleHerenciaManual} disabled={!corteSeleccionado || heredando} style={{
          background: heredando ? "#9ca3af" : "#1e40af", color: "white", border: "none",
          borderRadius: "8px", padding: "11px 24px", fontSize: "14px", fontWeight: "600",
          cursor: heredando ? "not-allowed" : "pointer", width: "100%"
        }}>
          {heredando ? "⏳ Aplicando herencia..." : "🔁 Aplicar herencia al corte seleccionado"}
        </button>

        {resultadoHerencia && (
          <div style={{ marginTop: "16px", background: "#dbeafe", border: "1px solid #93c5fd", borderRadius: "8px", padding: "16px" }}>
            <p style={{ margin: "0 0 6px 0", color: "#1e3a8a", fontWeight: "700" }}>✅ Herencia aplicada</p>
            <p style={{ margin: 0, color: "#1e40af", fontSize: "13px", lineHeight: 1.7 }}>
              🔁 Nodos actualizados: <strong>{resultadoHerencia.heredadas}</strong><br />
              📅 Desde corte: <strong>{resultadoHerencia.corte_origen}</strong><br />
              📅 Hacia corte: <strong>{resultadoHerencia.corte_destino}</strong>
            </p>
          </div>
        )}
        {errorHerencia && (
          <div style={{ marginTop: "16px", background: "#fef2f2", border: "1px solid #fca5a5", borderRadius: "8px", padding: "14px" }}>
            <p style={{ margin: 0, color: "#991b1b", fontWeight: "600" }}>⚠️ {errorHerencia}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default CargaDispo;